'use client';

import type { EventBus } from '@hc-frontend/core-events';
import { createDomEventBus } from '@hc-frontend/core-events';
import React, { createContext, useContext, useMemo } from 'react';

export const CoreEventBus = createContext<EventBus>({
  publish: () => undefined,
  subscribe: () => () => undefined,
  unsubscribe: () => undefined,
});

export function useEventBus() {
  const eventBus = useContext(CoreEventBus);

  return eventBus;
}

export function DomEventBusProvider({
  children,
}: React.PropsWithChildren): React.ReactNode {
  const eventBus = useMemo(createDomEventBus, []);
  return (
    <CoreEventBus.Provider value={eventBus}>{children}</CoreEventBus.Provider>
  );
}
